import { cmsCLient } from '@/services/axiosConfig'
import { LeasingInfo } from './types'

export type GetLeasingInfoRes = LeasingInfo

export type GetLeasingInfo = (id: number | undefined) => Promise<GetLeasingInfoRes>

export const getLeasingInfo: GetLeasingInfo = async (id) => {
  try {
    if (id !== undefined) {
      const response = await cmsCLient.get('/leasing-group?id=' + id.toString())
      return response.data.data
    }
  } catch (e: any) {
    return e.message
  }
}
